<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p>{{data.description}}</p>
  
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick(data.decision)">No</button>
  <button mat-button [mat-dialog-close]="onYes(data.decision)" cdkFocusInitial>Yes</button>
</div>